import script from "./ServicesMetricsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesMetricsRow.vue?vue&type=script&setup=true&lang=js"

import "./ServicesMetricsRow.vue?vue&type=style&index=0&id=12797da4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12797da4"]])

export default __exports__